// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html, body {
    overscroll-behavior: none;
}

body {
    margin: 0!important;
    width: 100%;
    height: 100%;
    position: relative;
    touch-action: none;
}

#game-container {
    position: fixed;
    height: 100%;
    width: 100%;
    z-index: 1;
    pointer-events: all!important;
}

.game-frame {
    position: absolute;
    width: 100%;
    height: 100%;
    border: none;
    overflow: hidden;
}

#root {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 2;
    pointer-events: none;
}

.loading-container {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 100;
    background: #000;
    transition: opacity 0.3s ease;
}

.loading-container.hide {
    opacity: 0;
}

.loading-block {
    position: absolute;
    width: 5vh;
    height: 5vh;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.loading-block:after {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    border: 5px solid transparent;
    border-top-color: #fff;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    z-index: 1;
}

.error-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 1000;
    display: flex;
    justify-content: center;
    align-items: center;
}

.error-modal {
    background-color: #c4c4c4;
    padding: 30px;
    border-radius: 20px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    text-align: center;
    max-width: 400px;
    width: 100%;
    margin: 20px;
}

.error-message {
    font-size: 20px;
    font-weight: bold;
    color: #000;
    margin-bottom: 20px;
}

.error-modal button {
    padding: 15px 30px;
    font-size: 18px;
    color: #DB2DC6;
    background-color: #fff;
    border: none;
    border-radius: 10px;
    cursor: pointer;
    text-transform: uppercase;
    font-weight: bold;
}

.error-modal button:hover {
    color: #BD00FF;
}


@keyframes spin {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}


#root .features {
    width: 100%;
    height: 100%;
    color: #c7c7c7;
    text-align: center;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}
`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,UAAU;IACV,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,sBAAsB;IACtB,kBAAkB;IAClB,kCAAkC;IAClC,UAAU;AACd;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,wCAAwC;IACxC,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,sBAAsB;IACtB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;;AAGA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;;;AAGA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,wIAAwI;AAC5I","sourcesContent":["html, body {\n    overscroll-behavior: none;\n}\n\nbody {\n    margin: 0!important;\n    width: 100%;\n    height: 100%;\n    position: relative;\n    touch-action: none;\n}\n\n#game-container {\n    position: fixed;\n    height: 100%;\n    width: 100%;\n    z-index: 1;\n    pointer-events: all!important;\n}\n\n.game-frame {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    border: none;\n    overflow: hidden;\n}\n\n#root {\n    position: fixed;\n    width: 100%;\n    height: 100%;\n    z-index: 2;\n    pointer-events: none;\n}\n\n.loading-container {\n    position: fixed;\n    width: 100%;\n    height: 100%;\n    z-index: 100;\n    background: #000;\n    transition: opacity 0.3s ease;\n}\n\n.loading-container.hide {\n    opacity: 0;\n}\n\n.loading-block {\n    position: absolute;\n    width: 5vh;\n    height: 5vh;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}\n\n.loading-block:after {\n    content: \"\";\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    border: 5px solid transparent;\n    border-top-color: #fff;\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n    z-index: 1;\n}\n\n.error-modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.8);\n    z-index: 1000;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.error-modal {\n    background-color: #c4c4c4;\n    padding: 30px;\n    border-radius: 20px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n    text-align: center;\n    max-width: 400px;\n    width: 100%;\n    margin: 20px;\n}\n\n.error-message {\n    font-size: 20px;\n    font-weight: bold;\n    color: #000;\n    margin-bottom: 20px;\n}\n\n.error-modal button {\n    padding: 15px 30px;\n    font-size: 18px;\n    color: #DB2DC6;\n    background-color: #fff;\n    border: none;\n    border-radius: 10px;\n    cursor: pointer;\n    text-transform: uppercase;\n    font-weight: bold;\n}\n\n.error-modal button:hover {\n    color: #BD00FF;\n}\n\n\n@keyframes spin {\n    0% {\n        transform: rotate(0deg);\n    }\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n\n#root .features {\n    width: 100%;\n    height: 100%;\n    color: #c7c7c7;\n    text-align: center;\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
